const baseTheme = () => {
    return {
        palette: {
            mode: 'dark',
            primary: {
                main: '#725146',
                contrastText: '#fff',
                hover: '#5c4037'
            },
            secondary: {
                main: '#d87030',
                contrastText: '#000'
            },
            tertiary: {
                main: '#555555',
                light: '#777777',
                dark: '#3b3b3b',
                contrastText: '#eeeeee'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
